import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'groupBy' })
export class SmGroupByPipe implements PipeTransform {
	transform(value: Array<any>, field: string): Array<any> {
		value = value || [];

		const groupedObj = value.reduce((prev, cur) => {
			if (!prev[cur[field]]) {
				prev[cur[field]] = [cur];
			} else {
				prev[cur[field]].push(cur);
			}
			return prev;
		}, {});

		return Object.keys(groupedObj).map(key => ({ key, value: groupedObj[key] }));
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/pipes/sm-groupby.pipe.ts